import React from "react";
import $ from "jquery";
import * as CryptoJS from "crypto-js";
import axios from "axios";
import { partnerPortal_Url } from "../Configuration/API_URL";



export const mobileVal = (e) => {
  var k = e.charCode;
  if ((k >= 48 && k <= 57) || k === 8) {
    if (e.target.value.length === 0) {
      if (k >= 54 && k <= 57) {
      } else {
        e.preventDefault();
      }
    }
    return true;
  } else {
    e.preventDefault();
  }
};
export const onlyNumber = (e) => {
  let length = e?.target?.value?.length;
  let existingValue = e?.target?.value?.slice(0, length - 1);
  let num1 = /^[0-9]*$/;
  if (!e?.target?.value?.match(num1)) {
    e.target.value = existingValue;
  }
};


export const validateEmail = (email) => {
  let emailRegex =
    /([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@([0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)*|\[((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|IPv6:((((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){6}|::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){5}|[0-9A-Fa-f]{0,4}::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){4}|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):)?(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){3}|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,2}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){2}|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,3}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,4}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::)((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3})|(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3})|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,5}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3})|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,6}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::)|(?!IPv6:)[0-9A-Za-z-]*[0-9A-Za-z]:[!-Z^-~]+)])/g;
  // /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if (email.length > 0) {
    return emailRegex.test(email);
  } else {
    return false;
  }
};

export const validateMobileNum =(num)=>{
  // let mobileRegex = /^[6-9]{1}[0-9]{9}$/
  // let mobileRegex = /^[6-9]*$/;
  let mobileRegex = /^[6789]\d{9}$/
  if (num.length > 0){
    return mobileRegex.test(num);
  } 
}

// export const validateIfsc=(ifsc)=>{
//   let ifscRegex = /^[A-Za-z]{4}[a-zA-Z0-9]{7}$/
//   if (ifsc.length > 0){
//     return ifscRegex.test(ifsc)
//   } else{
//     return false;
//   }
// }

export const checkEmpty = (value) => {
  if (value == undefined || null) return true;
  else return false;
};


export const mobileNumber = (mobile) => {
  let encodeDigit = "XXXXXX";
  let last4Digits = mobile?.substring(6);
  let contactNumber = encodeDigit + last4Digits;
  return contactNumber;
};


export const compareDate = (date) => {
  const currentDate = new Date();
  const inputDate = new Date(date);
  if (inputDate <= currentDate) {
    // setFileType(e.target.value);
    return true;
  } else {
    // setCheckDate(true);
    return false;
  }
};

//for capitalize

export function capitalize(word) {
  const lower = word.toLowerCase();
  return word.charAt(0).toUpperCase() + lower.slice(1);
}

// export const validatePan = (values) => {
//   var k = values.charCode;
//   if (values.target.value.length >= 0 && values.target.value.length < 5) {
//     if ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8) {
//       return true;
//     } else {
//       values.preventDefault();
//     }
//   }
//   if (values.target.value.length >= 5 && values.target.value.length < 9) {
//     if ((k >= 48 && k <= 57) || k === 8) {
//       return true;
//     } else {
//       values.preventDefault();
//     }
//   }
//   if (values.target.value.length >= 9 && values.target.value.length < 10) {
//     if ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8) {
//       return true;
//     } else {
//       values.preventDefault();
//     }
//   }
// };

export const validatePan = (e) => {
  const k = e.charCode;
  const cursorPos = e.target.selectionStart; // where user is typing

  // 1st to 3rd → Alphabets only
  if (cursorPos < 3) {
    if ((k >= 65 && k <= 90) || (k >= 97 && k <= 122)) {
      return true;
    } else {
      e.preventDefault();
    }
  }

  // 4th → must be P (force uppercase)
  else if (cursorPos === 3) {
    if (k === 80 || k === 112) {
      // 'P' or 'p'
      return true;
    } else {
      e.preventDefault();
    }
  }

  // 5th → Alphabet
  else if (cursorPos === 4) {
    if ((k >= 65 && k <= 90) || (k >= 97 && k <= 122)) {
      return true;
    } else {
      e.preventDefault();
    }
  }

  // 6th to 9th → Numbers only
  else if (cursorPos >= 5 && cursorPos < 9) {
    if (k >= 48 && k <= 57) {
      return true;
    } else {
      e.preventDefault();
    }
  }

  // 10th → Alphabet
  else if (cursorPos === 9) {
    if ((k >= 65 && k <= 90) || (k >= 97 && k <= 122)) {
      return true;
    } else {
      e.preventDefault();
    }
  }
};

export const inputPanVal = (e) => {
  let length = e.target.value.length;
  let enteredText = e.target.value.slice(-1);
  let existingValue = e.target.value.slice(0, length - 1);
  let aplhaRegex = /^[a-zA-Z]$/;
  let NumberRegex = /^[0-9]$/;

  if (length <= 5) {
    if (!enteredText.match(aplhaRegex)) {
      e.target.value = existingValue;
    }
  } else if (length <= 9) {
    if (!enteredText.match(NumberRegex)) {
      e.target.value = existingValue;
    }
  } else if (length <= 10) {
    if (!enteredText.match(aplhaRegex)) {
      e.target.value = existingValue;
    }
  } else {
    e.target.value = existingValue;
  }
};


// partner Portal methods

export const pauseAudio = () => {
  let audioFile = document.getElementById("audioEkyc");
  audioFile.pause();
};


export const dateInput = (e) => {
  e.target.value = e.target.value.replace(/[^0-9-]/g, "");
};

const resetInput = (e) => {
  let CursorCaret = e.target.selectionStart;
  let PreviousValue = e.target.value.slice(0, CursorCaret - 1) + e.target.value.slice(CursorCaret);
  e.target.value = PreviousValue
  e.target.setSelectionRange(CursorCaret - 1, CursorCaret - 1);
}
export const panInputResist = (e) => {
  let CursorCaret = e.target.selectionStart;
  let afterEnter = e.target.value;
  let PreviousValue = e.target.value.slice(0, CursorCaret - 1) + e.target.value.slice(CursorCaret);
  let enteredvalue = e.target.value.slice(CursorCaret - 1, CursorCaret)
  if (afterEnter.length > 10) {
    resetInput(e)
  } else {
    if ((CursorCaret >= 0 && CursorCaret <= 3) || CursorCaret === 5 || CursorCaret === 10) {
      if (afterEnter.length > PreviousValue.length) {
        if (!enteredvalue.match(/[A-Za-z]/i)) {
          resetInput(e)
        }
      }
    }
    if (CursorCaret === 4) {
      if (afterEnter.length > PreviousValue.length) {
        if (!enteredvalue.match(/[Pp]/i)) {
          resetInput(e)
        }
      }
    }
    if (CursorCaret >= 6 && CursorCaret <= 9) {
      if (afterEnter.length > PreviousValue.length) {
        if (!enteredvalue.match(/[0-9]/i)) {
          resetInput(e)
        }
      }
    }
  }
};


export const validatePartnerEmail = (email) => {
  let emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/
  // /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if (email.length > 0) {
    return emailRegex.test(email);
  } else {
    return false;
  }
};

export const validateInput = (value) => {
  let inputRegex =/^[a-zA-Z0-9\s,-.&#/]*$/;
  // /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if (value.length > 0) {
    return inputRegex.test(value);
  } else {
    return false;
  }
};

export const shareError = (value, block) => {
  // if (value.length !== 10) {
  //   $(`.${block}`).css("display", "block");
  //   $(`.${block}`).html("Enter Valid Date Format , DD-MM-YYYY");
  //   return false
  // }

  if (value?.reverseDob()?.underFutureDate() && value.reverseDob()?.isValidDate()) {
    let age = value?.reverseDob()?.getMinor();
    console.log(age);
    if (age) {
      $(`.${block}`).css("display", "none");
      $(`.${block}`).html("");
      return true;
    } else {
      $(`.${block}`).css("display", "block");
      $(`.${block}`).html("Below 18 year is not allowed");
      return false;
    }
  } else {
    $(`.${block}`).css("display", "block");
    $(`.${block}`).html("Enter Valid Date Format , DD-MM-YYYY");
    return false;
  }
};

export const ZeroPrefix = (number) => {

  let PrefixedNumber;
  if (parseInt(number) < 10 && !`${number}`.startsWith("0")) {
    PrefixedNumber = `0${number}`;
  } else {
    PrefixedNumber = number;
  }
  return PrefixedNumber;
};

export const digitValidate = (e) => {
  e.target.value = e.target.value.replace(/[^0-9]/g, "");
};

export const oneDigit = (e) => {
  // console.log(e.target.value.length);
  if (e.target.value.length > 1) {
    let value = String(e.target.value)[0];
    e.target.value = value;
  }
};

export const maxDateSet = (subtractYear = 0) => {
  let CurrentDate = new Date();
  let MinorDateSet = CurrentDate.setFullYear(
    CurrentDate.getFullYear() - subtractYear
  );
  let MinorFormat = new Date(MinorDateSet);
  let [day, month, year] = [
    MinorFormat.getDate(),
    MinorFormat.getMonth() + 1,
    MinorFormat.getFullYear(),
  ];

  month = ZeroPrefix(month);
  day = ZeroPrefix(day);
  return `${year}-${month}-${day}`;
};

export const decryptData=(data) =>{
 
  const iv = CryptoJS.enc.Hex.parse(data.substr(0,32))
  const ct = CryptoJS.enc.Hex.parse(data.substr(32))
  const key = CryptoJS.enc.Utf8.parse("6368616e676520746869732070617373")
  // @ts-ignore !!!!!!!! IMPORTANT IF YOU USE TYPESCRIPT COMPILER
  const decrypted = CryptoJS.AES.decrypt({ciphertext: ct}, key, {
    mode: CryptoJS.mode.CBC,
    iv: iv
  })
 
  console.log("Result : " + decrypted.toString(CryptoJS.enc.Utf8))
  return decrypted.toString(CryptoJS.enc.Utf8)
}
 
export const encryptData=(data)=> {
  const key = CryptoJS.enc.Utf8.parse("6368616e676520746869732070617373");
  const iv = CryptoJS.lib.WordArray.random(16); // Generate a random IV
 
  const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(data), key, {
    mode: CryptoJS.mode.CBC,
    iv: iv,
    padding: CryptoJS.pad.Pkcs7
  });
 
  // Combine IV and encrypted data
  const encryptedHex = iv.toString(CryptoJS.enc.Hex) + encrypted.ciphertext.toString(CryptoJS.enc.Hex);
 
  return encryptedHex;
}

export const AESDecryption = (data) => {
  
  const iv = "SLF1AMTkbk4PZsIC";
  const key = "OBlzjguunYOBsGx9";
  const fkey = CryptoJS.enc.Utf8.parse(key);
  const fiv = CryptoJS.enc.Utf8.parse(iv);
  return CryptoJS.AES.decrypt(data, fkey, {
    iv: fiv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8);
};
export const ApiResDecrypt = (data) => {
  let response = AESDecryption(data);
  return JSON.parse(JSON.parse(response));
};
export const LoginResDecrypt = (data) => {
  let response = AESDecryption(data);
  return JSON.parse(response);
};
export const AESEncryption = (data) => {
  const iv = "SLF1AMTkbk4PZsIC";
  const key = "OBlzjguunYOBsGx9";
  const fkey = CryptoJS.enc.Utf8.parse(key);
  const fiv = CryptoJS.enc.Utf8.parse(iv);
  const jsonString = JSON.stringify(data);
  const encryptedData = CryptoJS.AES.encrypt(jsonString, fkey, {
    iv: fiv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encryptedData.toString();
};


export const getSearchParameters = () => {
  var prmstr = window.location.search.substr(1);
    return prmstr !== null && prmstr !== "" ? transformToAssocArray(prmstr) : {};
};
export const transformToAssocArray = (prmstr) => {
  var params = {};
  var prmarr = prmstr.split("&");
  for (var i = 0; i < prmarr.length; i++) {
    var tmparr = prmarr[i].split("=");
    params[tmparr[0].toLowerCase()] = tmparr[1];
  }
  return params;
};

export const handleFileUpload = ({
  e,
  type,
  setFile,
  setError,
  allowedTypes = ["png", "jpeg", "jpg", "pdf"],
  maxSizeKB = 5120,
  callback,
}) => {
  const file = e?.target?.files?.[0];
  if (!file) return;

  const fileExtension = file.name.split(".").pop().toLowerCase();
  const size = Math.round(file.size / 1024);
  const specialCharRegex = /[^a-zA-Z0-9()._\s-]/;

  if (type === "5") {
    const allowedImageTypes = ["png", "jpeg", "jpg"];

    if (!allowedImageTypes.includes(fileExtension)) {
      setError("This file format is not supported.");
      return;
    }

    if (size > 5120) {
      setError("File size must be 5MB or less.");
      return;
    }
  } else {
    const allowedTypes = ["png", "jpeg", "jpg", "pdf"];

    if (!allowedTypes.includes(fileExtension)) {
      setError("This file format is not supported.");
      return;
    }

    // if (["png", "jpeg", "jpg"].includes(fileExtension) && size > 200) {
    //   setError("Images must be 200KB or less.");
    //   return;
    // }

    // if (fileExtension === "pdf" && size > 1024) {
    //   setError("PDF must be 1MB or less.");
    //   return;
    // }

    if (size > 5120) {
      setError("File size should be 5MB or less.");
      return;
    }

  }

  if (specialCharRegex.test(file.name)) {
    setError("Invalid file name.");
    return;
  }

  setError("");
  setFile(file);
  if (callback) callback();
};

export const validateIFSC = (event) => {
  const k = event.charCode;
  const length = event.target.value.length;

  // Allow Backspace
  if (k === 8) return true;

  if (length < 4) {
    // First 4 must be alphabets
    if ((k >= 65 && k <= 90) || (k >= 97 && k <= 122)) {
      return true;
    } else {
      event.preventDefault();
    }
  } else if (length === 4) {
    // 5th must be "0"
    if (k === 48) {
      return true;
    } else {
      event.preventDefault();
    }
  } else if (length > 4 && length < 11) {
    // Last 6 must be alphanumeric
    if (
      (k >= 65 && k <= 90) || // A-Z
      (k >= 97 && k <= 122) || // a-z
      (k >= 48 && k <= 57) // 0-9
    ) {
      return true;
    } else {
      event.preventDefault();
    }
  } else {
    // Prevent typing beyond 11
    event.preventDefault();
  }
};

export const handlePasteIFSC = (
  e,
  fieldName,
  setValue,
  setError,
  clearErrors,
  trigger
) => {
  e.preventDefault();

  const pastedText = e.clipboardData
    .getData("text")
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "")
    .slice(0, 11);

  const ifscPattern = /^[A-Z]{4}0[A-Z0-9]{6}$/;

  if (ifscPattern.test(pastedText)) {
    setValue(fieldName, pastedText, {
      shouldValidate: true,
      shouldDirty: true,
    });

    clearErrors(fieldName);
    trigger(fieldName);
  } else {
    setError(fieldName, {
      type: "manual",
      message: "Invalid IFSC Code",
    });
  }
};

export const handlePasteBankNumber = (
  e,
  type,
  setValue,
  trigger,
  setError,
  clearErrors,
  getValues
) => {
  e.preventDefault();

  const pasteData = e.clipboardData.getData("text");

  const digitsOnly = pasteData
    .replace(/\D/g, "")
    .slice(0, 18);

  if (!digitsOnly) return;

  if (type === "account") {
    setValue("accountNum", digitsOnly, {
      shouldValidate: true,
      shouldDirty: true,
    });

    trigger("accountNum");
  }

  if (type === "confirm") {
    const accountNum = getValues("accountNum");

    setValue("reAccountNum", digitsOnly, {
      shouldValidate: true,
      shouldDirty: true,
    });

    trigger("reAccountNum");

    if (accountNum && digitsOnly !== accountNum) {
      setError("reAccountNum", {
        type: "manual",
        message: "Bank account numbers must match",
      });
    } else {
      clearErrors("reAccountNum");
    }
  }
};


export const handlePanPaste = (
  e,
  fieldName,
  setValue,
  setError,
  clearErrors
) => {
  e.preventDefault();

  const pastedText = e.clipboardData
    .getData("text")
    .toUpperCase()
    .trim();

  const cleanText = pastedText
    .replace(/[^A-Z0-9]/g, "")
    .slice(0, 10);

  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

  if (panRegex.test(cleanText)) {
    setValue(fieldName, cleanText, {
      shouldValidate: true,
      shouldDirty: true,
    });

    clearErrors(fieldName);
  } else {
    setError(fieldName, {
      type: "manual",
      message: "Invalid PAN number",
    });
  }
};

export const handleNamePaste = (
  e,
  fieldName,
  setValue,
  getValues
) => {
  e.preventDefault();

  const pastedText = e.clipboardData.getData("text");

  const clean = pastedText
    .toUpperCase()
    .replace(/[^A-Z\s]/g, "")
    .replace(/\s+/g, " ")
    .trim();

  const currentVal = getValues(fieldName) || "";

  let newValue = `${currentVal} ${clean}`
    .replace(/\s+/g, " ")
    .trim();

  newValue = newValue.slice(0, 50);

  setValue(fieldName, newValue, {
    shouldValidate: true,
    shouldDirty: true,
  });

  e.target.value = newValue;
};

export const handlePasteAddress = (
  e,
  fieldName,
  setValue
) => {
  e.preventDefault();

  const pastedText = e.clipboardData.getData("text");

  let clean = pastedText
    .replace(/[^A-Za-z0-9\s\-.,'#\+\/()&@]/g, "")
    .replace(/\s{2,}/g, " ")
    .replace(/^\s+/, "")
    .slice(0, 50);

  if (clean === "") return;

  const input = e.target;

  const start = input.selectionStart;
  const end = input.selectionEnd;

  const currentValue = input.value;

  const newValue = (
    currentValue.slice(0, start) +
    clean +
    currentValue.slice(end)
  ).slice(0, 50);

  setValue(fieldName, newValue, {
    shouldValidate: true,
    shouldDirty: true,
  });

  input.value = newValue;

  const cursorPos = Math.min(start + clean.length, 50);

  setTimeout(() => {
    input.setSelectionRange(cursorPos, cursorPos);
  }, 0);
};

export const handlePastePincode = (
  e,
  fieldName,
  setValue
) => {
  e.preventDefault();

  const pastedText = e.clipboardData.getData("text");

  let clean = pastedText
    .replace(/\D/g, "")
    .trim()
    .slice(0, 6);

  if (clean === "") return;

  setValue(fieldName, clean, {
    shouldValidate: true,
    shouldDirty: true,
  });

  e.target.value = clean;
};


